import { z } from "zod";

export const getSivDataCarIconPresignedUrlQuerySchema = z
  .object({
    bucketFileName: z.string(),
  })
  .strict();

export type GetSivDataCarIconPresignedUrlQuery = z.infer<
  typeof getSivDataCarIconPresignedUrlQuerySchema
>;

export const getSivDataCarIconPresignedUrlResponseSchema = z
  .object({
    url: z.url(),
  })
  .strict();

export type GetSivDataCarIconPresignedUrlResponse = z.infer<
  typeof getSivDataCarIconPresignedUrlResponseSchema
>;
